function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { unwrap as aesKw } from '../runtime/aeskw.js';
import * as ECDH from '../runtime/ecdhes.js';
import { decrypt as pbes2Kw } from '../runtime/pbes2kw.js';
import { decrypt as rsaEs } from '../runtime/rsaes.js';
import { decode as base64url } from '../runtime/base64url.js';
import normalize from '../runtime/normalize_key.js';
import { JOSENotSupported, JWEInvalid } from '../util/errors.js';
import { bitLength as cekLength } from '../lib/cek.js';
import { importJWK } from '../key/import.js';
import checkKeyType from './check_key_type.js';
import isObject from './is_object.js';
import { unwrap as aesGcmKw } from './aesgcmkw.js';
function decryptKeyManagement(_x, _x2, _x3, _x4, _x5) {
  return _decryptKeyManagement.apply(this, arguments);
}
function _decryptKeyManagement() {
  _decryptKeyManagement = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(alg, key, encryptedKey, joseHeader, options) {
    var _normalize$normalizeP;
    var epk, partyUInfo, partyVInfo, sharedSecret, p2cLimit, p2s, iv, tag, _t, _t2, _t3, _t4, _t5, _t6, _t7;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          checkKeyType(alg, key, 'decrypt');
          _context.n = 1;
          return (_normalize$normalizeP = normalize.normalizePrivateKey) === null || _normalize$normalizeP === void 0 ? void 0 : _normalize$normalizeP.call(normalize, key, alg);
        case 1:
          _t = _context.v;
          if (_t) {
            _context.n = 2;
            break;
          }
          _t = key;
        case 2:
          key = _t;
          _t2 = alg;
          _context.n = _t2 === 'dir' ? 3 : _t2 === 'ECDH-ES' ? 5 : _t2 === 'ECDH-ES+A128KW' ? 6 : _t2 === 'ECDH-ES+A192KW' ? 6 : _t2 === 'ECDH-ES+A256KW' ? 6 : _t2 === 'RSA1_5' ? 19 : _t2 === 'RSA-OAEP' ? 19 : _t2 === 'RSA-OAEP-256' ? 19 : _t2 === 'RSA-OAEP-384' ? 19 : _t2 === 'RSA-OAEP-512' ? 19 : _t2 === 'PBES2-HS256+A128KW' ? 21 : _t2 === 'PBES2-HS384+A192KW' ? 21 : _t2 === 'PBES2-HS512+A256KW' ? 21 : _t2 === 'A128KW' ? 28 : _t2 === 'A192KW' ? 28 : _t2 === 'A256KW' ? 28 : _t2 === 'A128GCMKW' ? 30 : _t2 === 'A192GCMKW' ? 30 : _t2 === 'A256GCMKW' ? 30 : 38;
          break;
        case 3:
          if (!(encryptedKey !== undefined)) {
            _context.n = 4;
            break;
          }
          throw new JWEInvalid('Encountered unexpected JWE Encrypted Key');
        case 4:
          return _context.a(2, key);
        case 5:
          if (!(encryptedKey !== undefined)) {
            _context.n = 6;
            break;
          }
          throw new JWEInvalid('Encountered unexpected JWE Encrypted Key');
        case 6:
          if (isObject(joseHeader.epk)) {
            _context.n = 7;
            break;
          }
          throw new JWEInvalid("JOSE Header \"epk\" (Ephemeral Public Key) missing or invalid");
        case 7:
          if (ECDH.ecdhAllowed(key)) {
            _context.n = 8;
            break;
          }
          throw new JOSENotSupported('ECDH with the provided key is not allowed or not supported by your javascript runtime');
        case 8:
          _context.n = 9;
          return importJWK(joseHeader.epk, alg);
        case 9:
          epk = _context.v;
          if (!(joseHeader.apu !== undefined)) {
            _context.n = 12;
            break;
          }
          if (!(typeof joseHeader.apu !== 'string')) {
            _context.n = 10;
            break;
          }
          throw new JWEInvalid("JOSE Header \"apu\" (Agreement PartyUInfo) invalid");
        case 10:
          _context.p = 10;
          partyUInfo = base64url(joseHeader.apu);
          _context.n = 12;
          break;
        case 11:
          _context.p = 11;
          _t3 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the apu');
        case 12:
          if (!(joseHeader.apv !== undefined)) {
            _context.n = 15;
            break;
          }
          if (!(typeof joseHeader.apv !== 'string')) {
            _context.n = 13;
            break;
          }
          throw new JWEInvalid("JOSE Header \"apv\" (Agreement PartyVInfo) invalid");
        case 13:
          _context.p = 13;
          partyVInfo = base64url(joseHeader.apv);
          _context.n = 15;
          break;
        case 14:
          _context.p = 14;
          _t4 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the apv');
        case 15:
          _context.n = 16;
          return ECDH.deriveKey(epk, key, alg === 'ECDH-ES' ? joseHeader.enc : alg, alg === 'ECDH-ES' ? cekLength(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
        case 16:
          sharedSecret = _context.v;
          if (!(alg === 'ECDH-ES')) {
            _context.n = 17;
            break;
          }
          return _context.a(2, sharedSecret);
        case 17:
          if (!(encryptedKey === undefined)) {
            _context.n = 18;
            break;
          }
          throw new JWEInvalid('JWE Encrypted Key missing');
        case 18:
          return _context.a(2, aesKw(alg.slice(-6), sharedSecret, encryptedKey));
        case 19:
          if (!(encryptedKey === undefined)) {
            _context.n = 20;
            break;
          }
          throw new JWEInvalid('JWE Encrypted Key missing');
        case 20:
          return _context.a(2, rsaEs(alg, key, encryptedKey));
        case 21:
          if (!(encryptedKey === undefined)) {
            _context.n = 22;
            break;
          }
          throw new JWEInvalid('JWE Encrypted Key missing');
        case 22:
          if (!(typeof joseHeader.p2c !== 'number')) {
            _context.n = 23;
            break;
          }
          throw new JWEInvalid("JOSE Header \"p2c\" (PBES2 Count) missing or invalid");
        case 23:
          p2cLimit = (options === null || options === void 0 ? void 0 : options.maxPBES2Count) || 10000;
          if (!(joseHeader.p2c > p2cLimit)) {
            _context.n = 24;
            break;
          }
          throw new JWEInvalid("JOSE Header \"p2c\" (PBES2 Count) out is of acceptable bounds");
        case 24:
          if (!(typeof joseHeader.p2s !== 'string')) {
            _context.n = 25;
            break;
          }
          throw new JWEInvalid("JOSE Header \"p2s\" (PBES2 Salt) missing or invalid");
        case 25:
          _context.p = 25;
          p2s = base64url(joseHeader.p2s);
          _context.n = 27;
          break;
        case 26:
          _context.p = 26;
          _t5 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the p2s');
        case 27:
          return _context.a(2, pbes2Kw(alg, key, encryptedKey, joseHeader.p2c, p2s));
        case 28:
          if (!(encryptedKey === undefined)) {
            _context.n = 29;
            break;
          }
          throw new JWEInvalid('JWE Encrypted Key missing');
        case 29:
          return _context.a(2, aesKw(alg, key, encryptedKey));
        case 30:
          if (!(encryptedKey === undefined)) {
            _context.n = 31;
            break;
          }
          throw new JWEInvalid('JWE Encrypted Key missing');
        case 31:
          if (!(typeof joseHeader.iv !== 'string')) {
            _context.n = 32;
            break;
          }
          throw new JWEInvalid("JOSE Header \"iv\" (Initialization Vector) missing or invalid");
        case 32:
          if (!(typeof joseHeader.tag !== 'string')) {
            _context.n = 33;
            break;
          }
          throw new JWEInvalid("JOSE Header \"tag\" (Authentication Tag) missing or invalid");
        case 33:
          _context.p = 33;
          iv = base64url(joseHeader.iv);
          _context.n = 35;
          break;
        case 34:
          _context.p = 34;
          _t6 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the iv');
        case 35:
          _context.p = 35;
          tag = base64url(joseHeader.tag);
          _context.n = 37;
          break;
        case 36:
          _context.p = 36;
          _t7 = _context.v;
          throw new JWEInvalid('Failed to base64url decode the tag');
        case 37:
          return _context.a(2, aesGcmKw(alg, key, encryptedKey, iv, tag));
        case 38:
          throw new JOSENotSupported('Invalid or unsupported "alg" (JWE Algorithm) header value');
        case 39:
          return _context.a(2);
      }
    }, _callee, null, [[35, 36], [33, 34], [25, 26], [13, 14], [10, 11]]);
  }));
  return _decryptKeyManagement.apply(this, arguments);
}
export default decryptKeyManagement;